// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// /home/kepler/code/github/expense-manager-firebase/~/core-js/modules/_enum-bug-keys.js
// module id = ../../../../core-js/modules/_enum-bug-keys.js
// module chunks = 0